module.exports = __webpack_public_path__ + "img/cocteleria_5.c6a4d8b1.jpeg";